// ricola-reveal: adds .is-inview to .ric-reveal elements as they enter the viewport.
// Editor-safe: re-scans on shopify:section:load (Theme Editor add/select), and
// reveals anything already on-screen immediately so content never gets stuck hidden.
if (typeof window !== 'undefined' && !window.__ricReveal) {
  window.__ricReveal = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
  const run = () => document.querySelectorAll('.ric-reveal:not(.is-inview)').forEach((el) => {
    // already visible (or reduced motion / theme editor) -> reveal now, don't wait for scroll
    const r = el.getBoundingClientRect();
    if (reduce || (r.top < innerHeight && r.bottom > 0)) el.classList.add('is-inview');
    else io.observe(el);
  });
  if (document.readyState !== 'loading') run(); else addEventListener('DOMContentLoaded', run);
  // Shopify Theme Editor: sections are injected after load — re-scan them.
  document.addEventListener('shopify:section:load', () => setTimeout(run, 50));
}
